/**
 * 広告から来た人の印（2026-10-18 gtm/early-fixes・GTM の確認 docs/teams/gtm/early-review.md の直す案 2・管理の指示書 docs/teams/gtm/tasks/early-fixes.md）。
 *
 * WHY: 広告（Reddit）は「Your AI built the game … tell it "publish this game"」= 来る人は**もうゲームを持っている**。なのに登録の後のホームの最初の頼み・
 *   つなぐ文の締めは「Make a small game …」= 新しいゲームを作らせる寄り道になる。広告から来た人だけ「Publish this game …」を一番上に出したい。
 *   登録の画面は URL の src（inviteCode.ts adSourceFromSearch）と OAuth の控えの fromAd で広告から来たと分かるが、ホームに移ると URL から消える。
 *   そこで登録が通ったとき（メールの登録の成功・Google / GitHub の新規登録）に、この端末へ印を 1 つ残す。
 *
 * 持つもの: 印を付けた時刻だけ（`{"at": <ミリ秒>}`）。src のラベル・招待コード・メールは持たない（使うのは「広告から来たか」だけ）。
 * WHY localStorage か（sessionStorage でないか）: 登録 → メールの確認（メールのアプリから別のタブで開く）→ ホーム、とタブをまたぐ。
 *   サーバーに持たせる（アカウントの列）と migration が要る = 広告の第 1 段の前に入れるには重い。端末を替えた人は印が無い = 今までの頼み（壊れない）。
 * WHY 30 日で消えるか: 印は「最初のゲームを公開するまで」のためのもの。ずっと残すと、同じ端末で後から作った別のアカウントにも出る。
 * 読めない（プライベートの Safari など）・壊れた値 = 印なし = ほかの入口の人と同じ画面（lastLogin.ts と同じ扱い）。
 * このファイルは import を持たない（node --test で型の除去だけで動かす・inviteCode.ts と同じ）。テストは adVisit.test.ts
 */

/** localStorage のキー。v1 = 形を変えたら v2 にして古い値は読まない */
export const AD_VISIT_KEY = 'kumo.adVisit.v1';
/** 印が効く日数（上の WHY） */
export const AD_VISIT_DAYS = 30;

type KvStorage = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

/** 登録が通ったときに呼ぶ。書けない環境では何もしない（画面を止めない） */
export function markAdVisit(storage: KvStorage | null, now: number): void {
  if (!storage) return;
  try {
    storage.setItem(AD_VISIT_KEY, JSON.stringify({ at: now }));
  } catch {
    // 書けない = 印なし（ほかの入口の人と同じ画面）
  }
}

/** この端末で、30 日以内に広告から登録したか */
export function cameFromAd(storage: KvStorage | null, now: number): boolean {
  if (!storage) return false;
  try {
    const raw = storage.getItem(AD_VISIT_KEY);
    if (!raw) return false;
    const v = JSON.parse(raw) as { at?: unknown } | null;
    const at = v && typeof v === 'object' ? v.at : undefined;
    if (typeof at !== 'number' || !Number.isFinite(at) || at < 0) return false;
    // 未来の印（時計が戻った・自分で書いた値ではない）も信じない
    return at <= now && now - at <= AD_VISIT_DAYS * 86_400_000;
  } catch {
    return false;
  }
}
